import { CustomProductDraft, OrganizationTableItem } from 'types'

export const toServiceKey = (p: any) => {
  const raw =
    (typeof p === 'string' && p) ||
    (typeof p?.serviceKey === 'string' && p.serviceKey) ||
    (typeof p?.title === 'string' && p.title) ||
    (typeof p?.productName === 'string' && p.productName) ||
    (typeof p?.name === 'string' && p.name) ||
    '' // fallback

  // If raw is still not a string, stop early.
  if (typeof raw !== 'string') return ''

  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

export const existingServiceKeys = (mergedDrafts: CustomProductDraft[]) => {
  return new Set((mergedDrafts ?? []).map(d => String(d?.SK ?? '').replace('PRODUCT_CUSTOM_', '')).filter(Boolean))
}
export const archivedServiceKeys = (unique_custom_products: OrganizationTableItem[]) => {
  if (!Array.isArray(unique_custom_products) || unique_custom_products?.length === 0) return new Set()

  const archivedProducts = unique_custom_products?.filter(p => p?.isArchived)
  return new Set((archivedProducts ?? [])?.map(p => String(p?.SK ?? '').replace('PRODUCT_CUSTOM_', '')).filter(Boolean))
}
